import { Box, Tab, Tabs } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import {
    useBookingNotesQuery,
    useBookingAttachmentsQuery,
    useBookingByIdWithMetaQueryObserver,
    useAttachmentTypeQuery
} from "../../../api/services";
import { BookingManagementPageTabs } from "../types";
import { TabAttachments, TabBookingEntity, TabChangeLog, TabDriverDetails, TabMessages, TabNotes, TabSubstitution } from "./tabs";
import { RouteParams } from "../../../types";

const TabsManager = () => {

    const { id: bookingId } = useParams<RouteParams>();

    const { t } = useTranslation('booking');

    const bookingNotesQuery = useBookingNotesQuery(bookingId);
    const bookingQuery = useBookingByIdWithMetaQueryObserver(bookingId);
    useBookingAttachmentsQuery(bookingId);
    useAttachmentTypeQuery(bookingId);

    const [tab, setTab] = useState<BookingManagementPageTabs>(BookingManagementPageTabs.BOOKING_ENTITY);

    const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    }, []);

    return (
        <Box px={2} pt={2}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tab} onChange={handleChangeTab}>
                    <Tab
                        label={t('label.bookingDetails')}
                        value={BookingManagementPageTabs.BOOKING_ENTITY}
                    />
                    <Tab
                        label={t('label.customerDetails')}
                        value={BookingManagementPageTabs.DRIVER_DETAILS}
                    />
                    { bookingQuery?.data?.booking?.substitution &&
                        <Tab
                            label={t('label.substitutionDetails')}
                            value={BookingManagementPageTabs.SUBSTITUTIONS}
                        />
                    }
                    <Tab
                        label={t('label.changelog')}
                        value={BookingManagementPageTabs.CHANGE_LOG}
                    />
                    <Tab
                        label={t('label.attachments')}
                        value={BookingManagementPageTabs.ATTACHMENTS}
                    />
                    {/*  <Tab label={t('label.messages')} disabled /> */}
                    <Tab
                        label={`${t('label.notes')} (${bookingNotesQuery.data?.length ?? 0})`}
                        value={BookingManagementPageTabs.NOTES}
                    />
                </Tabs>
            </Box>
            <Box py={3}>
                {tab === BookingManagementPageTabs.BOOKING_ENTITY &&
                    <TabBookingEntity />
                }
                {tab === BookingManagementPageTabs.DRIVER_DETAILS &&
                    <TabDriverDetails />
                }
                {tab === BookingManagementPageTabs.SUBSTITUTIONS &&
                <TabSubstitution />
                }
                {tab === BookingManagementPageTabs.CHANGE_LOG &&
                    <TabChangeLog />
                }
                {tab === BookingManagementPageTabs.ATTACHMENTS &&
                    <TabAttachments />
                }
                {tab === BookingManagementPageTabs.MESSAGES &&
                    <TabMessages />
                }
                {tab === BookingManagementPageTabs.NOTES &&
                    <TabNotes />
                }
            </Box>
        </Box>
    )
};

export default TabsManager;
